/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyVersionModel } from '../../models/client-survey-version-model';

export interface GetSurveyVersionById$Json$Params {

/**
 * id of surveyversion for filter
 */
  surveyVersionId: number;
}

export function getSurveyVersionById$Json(http: HttpClient, rootUrl: string, params: GetSurveyVersionById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyVersionById$Json.PATH, 'get');
  if (params) {
    rb.path('surveyVersionId', params.surveyVersionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyVersionModel>;
    })
  );
}

getSurveyVersionById$Json.PATH = '/api/SurveyVersion/{surveyVersionId}';
